import { FileUploaderOptions } from 'ng2-file-upload';

export class AppSettings {
  public static readonly DATE_FORMAT = 'yyyy-MM-dd';
  public static readonly DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
  public static readonly TITLE_PREFIX = 'Amica BIZNES+ -';

  public static readonly FILE_UPLOADER_OPTIONS: FileUploaderOptions = {
    url: '',
    disableMultipart: false,
    autoUpload: false,
    queueLimit: 1,
    maxFileSize: 5242880, // 5mb
    allowedFileType: ['image', 'pdf'],
    allowedMimeType: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
  };
}
